import { Controller } from 'stimulus'
import jstz from 'jstz'

export default class extends Controller {
  connect() {
    const time_zones_in_brazil =
      ['America/Eirunepe', 'America/Rio_Branco', 'America/Boa_Vista',
      'America/Campo_Grande', 'America/Cuiaba', 'America/Manaus',
      'America/Porto_Velho', 'America/Araguaina', 'America/Bahia',
      'America/Belem', 'America/Fortaleza', 'America/Maceio', 'America/Recife',
      'America/Santarem', 'Brasilia', 'America/Noronha']

    const timezone = jstz.determine()

    let user_time_zone;
    if (time_zones_in_brazil.includes(timezone.name())) {
      user_time_zone = timezone.name()
    } else {
      user_time_zone = 'Brasilia'
    }

    $(this.element).val(user_time_zone)
  }
}
